<template>
	<div class="map" id="map"></div>
</template>

<script>
	import L from "leaflet";

	export default {
		props: {
			route: Array,
		},
		data() {
			return {
				map: undefined,
				polyline: undefined,
			};
		},
		methods: {
			initializeMap() {
				//Workaround for webpack not importing the icons
				delete L.Icon.Default.prototype._getIconUrl;

				L.Icon.Default.mergeOptions({
					iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
					iconUrl: require("leaflet/dist/images/marker-icon.png"),
					shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
				});
				//End of workaround

				//Create the map
				this.map = L.map(`map`).setView(
					[this.route[0].x, this.route[0].y],
					13
				);

				//Then add the tile layer
				L.tileLayer(
					"https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
					{
						attribution:
							'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
						maxZoom: 21,
						id: "mapbox/streets-v11",
						tileSize: 512,
						zoomOffset: -1,
						accessToken: process.env.VUE_APP_MAP_TOKEN,
					}
				).addTo(this.map);

				this.polyline = new L.Polyline(
					this.route.map((coord) => [coord.x, coord.y]),
					{
						color: "red",
						weight: 6,
						opacity: 0.5,
						smoothFactor: 1,
					}
				);

				L.marker(new L.LatLng(this.route[0].x, this.route[0].y))
					.addTo(this.map)
					.bindTooltip("Inicio", {
						permanent: true,
						direction: "left",
					});

				L.marker(
					new L.LatLng(
						this.route[this.route.length - 1].x,
						this.route[this.route.length - 1].y
					)
				)
					.addTo(this.map)
					.bindTooltip("Fin", {
						permanent: true,
						direction: "right",
					});

				this.polyline.addTo(this.map);

				this.map.fitBounds(this.polyline.getBounds());
			},
		},
		watch: {
			route(val) {
				if (val.length > 1) {
					this.initializeMap();
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.map {
		height: 100%;
		width: 100%;
	}
</style>